export default "__VITE_ASSET__BMH_fQGP__"